class Environment {
  static #KNOWN_ENVIRONMENTS = {
    development: 'development',
    staging: 'staging',
    stg: 'stg',
    production: 'production',
    prd: 'prd',
    local: 'local',
  };

  constructor(runtimeEnvironment) {
    this.currentEnv = runtimeEnvironment in Environment.#KNOWN_ENVIRONMENTS
      ? runtimeEnvironment
      : Environment.#KNOWN_ENVIRONMENTS.local;

    console.log('currentEnv', this.currentEnv);
  }

  get current() {
    return this.currentEnv;
  }

  get isLocal() {
    return this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.local;
  }

  get isDevelopment() {
    return this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.development;
  }

  get isDevMode() {
    return this.isLocal || this.isDevelopment;
  }

  get isStaging() {
    return (
      this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.staging
      || this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.stg
    );
  }

  get isProd() {
    return (
      this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.production
      || this.currentEnv === Environment.#KNOWN_ENVIRONMENTS.prd
    );
  }

  isOneOf(envArray) {
    if (!Array.isArray(envArray)) {
      throw new TypeError('isOneOf expects an array');
    }
    return envArray.includes(this.currentEnv);
  }
}

const environment = new Environment(import.meta.env.VITE_ENVIRONMENT);
export default environment;
